import * as React from 'react'
import { Provider } from 'react-redux'
import createStore from '../src/store/createStore'

const { store } = createStore()

export default (story: () => React.ReactNode) => (
  <Provider store={store}>{story()}</Provider>
)
